// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container styling */

.container {
    max-width: 100%;
    margin: 40px auto;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}


/* Form labels styling */

label {
    font-weight: 600;
    margin-bottom: 5px;
    color: #333333;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
}


/* Input fields styling */

.form-control {
    padding: 12px 15px;
    font-size: 15px;
    border-radius: 8px;
    border: 1px solid #ced4da;
    background-color: #ffffff;
    transition: all 0.3s ease;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-control:focus {
    border-color: #007bff;
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}


/* Table styling */

.table-responsive {
    margin-top: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.table {
    border-collapse: separate;
    border-spacing: 0 10px;
    width: 100%;
}

.table thead {
    background-color: #007bff;
    color: #ffffff;
    border-radius: 8px;
}

.table th {
    padding: 12px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.table tbody tr {
    background-color: #ffffff;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.table tbody tr:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table tbody td {
    padding: 12px;
    font-size: 14px;
    border-top: none;
}


/* Button styling */

.button-container {
    display: flex;
    justify-content: flex-end;
    /* Aligns button to the right */
    width: 100%;
    margin-top: 20px;
}

button.btn-primary {
    width: 20%;
    padding: 12px;
    font-size: 16px;
    background-color: #4E3B31;
    border: none;
    border-radius: 8px;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

button.btn-primary:hover {
    background-color: #4E3B31;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}


/* Search input styling */

#searchQuery {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border-radius: 8px;
    border: 1px solid #ced4da;
    margin-top: 10px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

#searchQuery:focus {
    border-color: #007bff;
    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}


/* Headings */

h2 {
    font-weight: bold;
    color: #333333;
    font-size: 24px;
    margin-bottom: 25px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
}


/* Feedback for invalid input */

.form-control.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 8px rgba(220, 53, 69, 0.2);
}

.form-control-feedback {
    font-size: 13px;
    color: #dc3545;
}


/* Spacing */

.mt-3 {
    margin-top: 1.5rem !important;
}

.my-4 {
    margin: 2.5rem 0 !important;
}


/* Responsive design adjustments */

@media (max-width: 992px) {
    .container {
        padding: 20px;
    }
    .form-control {
        font-size: 14px;
        padding: 10px 12px;
    }
    button.btn-primary {
        width: 30%;
        /* Adjust button width for medium screens */
    }
}

@media (max-width: 768px) {
    label {
        font-size: 13px;
    }
    .table th,
    .table td {
        font-size: 13px;
        padding: 10px;
    }
    button.btn-primary {
        width: 40%;
        /* Adjust button width for smaller screens */
    }
    h2 {
        font-size: 22px;
    }
}

@media (max-width: 576px) {
    .container {
        padding: 15px;
    }
    label {
        font-size: 12px;
    }
    .form-control {
        font-size: 13px;
        padding: 8px 10px;
    }
    .table th,
    .table td {
        font-size: 12px;
        padding: 8px;
    }
    button.btn-primary {
        width: 60%;
        /* Adjust button width for very small screens */
    }
    h2 {
        font-size: 20px;
    }
}

.table thead th {
    color: #fafafa;
    /* Example: Coral color for headers */
    font-weight: bold;
    padding: 12px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.btn-ChangePass {
    background: #4E3B31;
    transition: all .5s;
    color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/style/Account.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;;AAGA,wBAAwB;;AAExB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA,yBAAyB;;AAEzB;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;;AAGA,kBAAkB;;AAElB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;;AAGA,mBAAmB;;AAEnB;IACI,aAAa;IACb,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;AAC9C;;;AAGA,yBAAyB;;AAEzB;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;;AAGA,aAAa;;AAEb;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;;AAGA,+BAA+B;;AAE/B;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA,YAAY;;AAEZ;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA,kCAAkC;;AAElC;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,2CAA2C;IAC/C;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;QACf,aAAa;IACjB;IACA;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;;QAEI,eAAe;QACf,YAAY;IAChB;IACA;QACI,UAAU;QACV,+CAA+C;IACnD;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B","sourcesContent":["/* General container styling */\r\n\r\n.container {\r\n    max-width: 100%;\r\n    margin: 40px auto;\r\n    padding: 30px;\r\n    border-radius: 12px;\r\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n/* Form labels styling */\r\n\r\nlabel {\r\n    font-weight: 600;\r\n    margin-bottom: 5px;\r\n    color: #333333;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n}\r\n\r\n\r\n/* Input fields styling */\r\n\r\n.form-control {\r\n    padding: 12px 15px;\r\n    font-size: 15px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ced4da;\r\n    background-color: #ffffff;\r\n    transition: all 0.3s ease;\r\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.form-control:focus {\r\n    border-color: #007bff;\r\n    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n\r\n/* Table styling */\r\n\r\n.table-responsive {\r\n    margin-top: 20px;\r\n    background-color: #ffffff;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.table {\r\n    border-collapse: separate;\r\n    border-spacing: 0 10px;\r\n    width: 100%;\r\n}\r\n\r\n.table thead {\r\n    background-color: #007bff;\r\n    color: #ffffff;\r\n    border-radius: 8px;\r\n}\r\n\r\n.table th {\r\n    padding: 12px;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n}\r\n\r\n.table tbody tr {\r\n    background-color: #ffffff;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.table tbody tr:hover {\r\n    transform: translateY(-3px);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.table tbody td {\r\n    padding: 12px;\r\n    font-size: 14px;\r\n    border-top: none;\r\n}\r\n\r\n\r\n/* Button styling */\r\n\r\n.button-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    /* Aligns button to the right */\r\n    width: 100%;\r\n    margin-top: 20px;\r\n}\r\n\r\nbutton.btn-primary {\r\n    width: 20%;\r\n    padding: 12px;\r\n    font-size: 16px;\r\n    background-color: #4E3B31;\r\n    border: none;\r\n    border-radius: 8px;\r\n    color: #ffffff;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    transition: background-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\nbutton.btn-primary:hover {\r\n    background-color: #4E3B31;\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n\r\n/* Search input styling */\r\n\r\n#searchQuery {\r\n    width: 100%;\r\n    padding: 12px;\r\n    font-size: 16px;\r\n    border-radius: 8px;\r\n    border: 1px solid #ced4da;\r\n    margin-top: 10px;\r\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n#searchQuery:focus {\r\n    border-color: #007bff;\r\n    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n\r\n/* Headings */\r\n\r\nh2 {\r\n    font-weight: bold;\r\n    color: #333333;\r\n    font-size: 24px;\r\n    margin-bottom: 25px;\r\n    text-align: center;\r\n    letter-spacing: 1px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n\r\n/* Feedback for invalid input */\r\n\r\n.form-control.is-invalid {\r\n    border-color: #dc3545;\r\n    box-shadow: 0 0 8px rgba(220, 53, 69, 0.2);\r\n}\r\n\r\n.form-control-feedback {\r\n    font-size: 13px;\r\n    color: #dc3545;\r\n}\r\n\r\n\r\n/* Spacing */\r\n\r\n.mt-3 {\r\n    margin-top: 1.5rem !important;\r\n}\r\n\r\n.my-4 {\r\n    margin: 2.5rem 0 !important;\r\n}\r\n\r\n\r\n/* Responsive design adjustments */\r\n\r\n@media (max-width: 992px) {\r\n    .container {\r\n        padding: 20px;\r\n    }\r\n    .form-control {\r\n        font-size: 14px;\r\n        padding: 10px 12px;\r\n    }\r\n    button.btn-primary {\r\n        width: 30%;\r\n        /* Adjust button width for medium screens */\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    label {\r\n        font-size: 13px;\r\n    }\r\n    .table th,\r\n    .table td {\r\n        font-size: 13px;\r\n        padding: 10px;\r\n    }\r\n    button.btn-primary {\r\n        width: 40%;\r\n        /* Adjust button width for smaller screens */\r\n    }\r\n    h2 {\r\n        font-size: 22px;\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .container {\r\n        padding: 15px;\r\n    }\r\n    label {\r\n        font-size: 12px;\r\n    }\r\n    .form-control {\r\n        font-size: 13px;\r\n        padding: 8px 10px;\r\n    }\r\n    .table th,\r\n    .table td {\r\n        font-size: 12px;\r\n        padding: 8px;\r\n    }\r\n    button.btn-primary {\r\n        width: 60%;\r\n        /* Adjust button width for very small screens */\r\n    }\r\n    h2 {\r\n        font-size: 20px;\r\n    }\r\n}\r\n\r\n.table thead th {\r\n    color: #fafafa;\r\n    /* Example: Coral color for headers */\r\n    font-weight: bold;\r\n    padding: 12px;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n}\r\n\r\n.btn-ChangePass {\r\n    background: #4E3B31;\r\n    transition: all .5s;\r\n    color: #fff !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
